import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from '@fs/zion-router'
import { H5 } from '@fs/zion-ui'
import { usePageView } from '@fs/zion-analytics'
import { PermissionsContext } from '../app/PermissionsContext'
import TreeSummary from './summary/TreeSummary'
import SubnavAndRoutes from '../app/SubnavAndRoutes'
import TreeChanges from './changes/TreeChanges'
import TreeContextProvider from './TreeContextProvider'
import useTree from './useTree'
import TreeDetailChanges from './detail-changes/TreeDetailChanges'
import { usePageTitle } from '../app/PageTitleContext'

export default function TreeBase() {
  usePageView({ page_detail: 'DMConsole:TreeBase' })
  const { t } = useTranslation()
  usePageTitle(t('pageTitle.tree.base'))
  const { isRole } = useContext(PermissionsContext)
  const { treeId } = useParams()
  const treeContext = useTree(treeId)
  const { state } = treeContext

  if (!isRole(['Engineer Admin', 'Data Admin 4', 'Data Admin 5', 'Data Admin 6'])) {
    return <H5>{t('not.authorized.greeting', 'Not authorized')}</H5>
  }
  if (!treeId) {
    return t('tree.msg.lookup', 'Please look up a tree by ID')
  }

  const subNavs = [
    {
      text: t('tree.summary', 'Summary'),
      path: 'summary',
      requiredPermissions: ['FtLoginPermission'],
      component: TreeSummary,
    },
  ]

  if (state.tree?.researcherTree) {
    subNavs.push({
      text: t('tree.personChanges', 'Person Changes'),
      path: 'person-changes',
      requiredPermissions: ['FtLoginPermission'],
      component: TreeChanges,
    })
  }

  subNavs.push({
    text: t('tree.detailChanges', 'Detail Changes'),
    path: 'detail-changes',
    requiredPermissions: ['FtLoginPermission'],
    component: TreeDetailChanges,
  })

  return (
    <TreeContextProvider value={treeContext}>
      <SubnavAndRoutes data={subNavs} />
    </TreeContextProvider>
  )
}
